import { render, staticRenderFns } from "./KNXSuitcase.vue?vue&type=template&id=4b520ba3"
import script from "./KNXSuitcase.vue?vue&type=script&lang=js"
export * from "./KNXSuitcase.vue?vue&type=script&lang=js"
import style0 from "./KNXSuitcase.vue?vue&type=style&index=0&id=4b520ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./KNXSuitcase.vue?vue&type=custom&index=0&blockType=meta&name=viewport&content=width%3Ddevice-width%2C%20initial-scale%3D1.0"
if (typeof block0 === 'function') block0(component)

export default component.exports